import React, { useState } from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import {
  Menu,
  X,
  LogOut,
  Home,
  QrCode,
  User,
  Coffee,
  BookOpen,
  Settings,
  Crown,
} from 'lucide-react';
import logo from './../../assets/logo.svg';
import { useNavigate } from 'react-router-dom';

const Layout = ({ user, logout }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  const navLinkClass = ({ isActive }) =>
    [
      'relative px-4 py-2 text-lg transition-colors duration-200',
      'hover:text-tree-green hover:cursor-pointer',
      isActive
        ? [
            'text-tree-green after:absolute after:bottom-0 after:left-0',
            'after:w-full after:h-0.5 after:bg-tree-green font-medium',
          ].join(' ')
        : 'text-slate-500',
    ].join(' ');

  const mobileNavLinkClass = ({ isActive }) =>
    [
      'relative px-4 py-2 text-lg transition-colors duration-200 flex items-center space-x-2',
      'hover:text-tree-green hover:cursor-pointer',
      isActive
        ? [
            'text-tree-green after:absolute after:bottom-0 after:left-0',
            'after:w-full after:h-0.5 after:bg-tree-green font-medium',
          ].join(' ')
        : 'text-slate-500',
    ].join(' ');

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <div className='bg-[#fefafc] flex flex-col min-h-screen'>
      <nav className='bg-white shadow-md sticky top-0 z-50'>
        <div className='lg:px-8 max-w-7xl mx-auto px-4 sm:px-6'>
          <div className='flex h-16 items-center justify-between'>
            {/* Logo and Brand */}
            <div
              className='flex items-center'
              onClick={() => navigate('/')}
              style={{ cursor: 'pointer' }}>
              <img
                src={logo}
                alt='logo'
                className='h-10 mr-2 w-auto'
              />
              <p
                className='text-2xl'
                style={{
                  fontFamily: 'Fredoka, sans-serif',
                  fontStyle: 'normal',
                  color: '#22543D',
                }}>
                <span style={{ fontWeight: 700 }}>TreeHacks</span>{' '}
                <span style={{ fontWeight: 400 }}>Scan</span>
              </p>
            </div>

            {/* Desktop Navigation */}
            <div className='hidden items-center md:flex space-x-1'>
              <NavLink
                to='/'
                className={navLinkClass}>
                home
              </NavLink>
              <NavLink
                to='/hacker'
                className={navLinkClass}>
                hacker
              </NavLink>
              {/* <NavLink
                to='/mentor'
                className={navLinkClass}>
                mentor
              </NavLink> */}
              <NavLink
                to='/judge'
                className={navLinkClass}>
                judge
              </NavLink>
              <NavLink
                to='/workshops'
                className={navLinkClass}>
                workshops
              </NavLink>
              <NavLink
                to='/hardware'
                className={navLinkClass}>
                hardware
              </NavLink>
              {user?.attributes?.isLeadership && (
                <NavLink
                  to='/admin'
                  className={navLinkClass}>
                  admin
                </NavLink>
              )}
            </div>
            <div className='hidden items-center md:flex'>
              <button
                onClick={logout}
                className='duration-200 flex hover:text-tree-green items-center px-4 py-2 space-x-2 text-lg text-slate-500 transition-colors'>
                <LogOut className='h-5 w-5' />
                <span>log out</span>
              </button>
            </div>

            {/* Mobile Menu Button */}
            <div className='md:hidden'>
              <button
                onClick={toggleMenu}
                className='hover:bg-gray-100 hover:text-tree-green p-2 rounded-md text-gray-600'>
                {isMenuOpen ? (
                  <X className='h-6 w-6' />
                ) : (
                  <Menu className='h-6 w-6' />
                )}
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Navigation */}
        <div
          className={`${
            isMenuOpen ? 'block' : 'hidden'
          } md:hidden border-t border-gray-200 max-h-96 overflow-y-auto`}>
          <div className='flex flex-col py-2 space-y-1'>
            <NavLink
              to='/'
              className={mobileNavLinkClass}>
              <Home className='h-5 w-5' />
              <span>home</span>
            </NavLink>
            <NavLink
              to='/info'
              className={mobileNavLinkClass}>
              <QrCode className='h-5 w-5' />
              <span>info</span>
            </NavLink>
            <NavLink
              to='/checkin'
              className={mobileNavLinkClass}>
              <User className='h-5 w-5' />
              <span>check in</span>
            </NavLink>
            <NavLink
              to='/meals'
              className={mobileNavLinkClass}>
              <Coffee className='h-5 w-5' />
              <span>meals</span>
            </NavLink>
            <NavLink
              to='/workshops'
              className={mobileNavLinkClass}>
              <BookOpen className='h-5 w-5' />
              <span>workshops</span>
            </NavLink>
            <NavLink
              to='/hardware'
              className={mobileNavLinkClass}>
              <Settings className='h-5 w-5' />
              <span>hardware</span>
            </NavLink>

            {user?.attributes?.isLeadership && (
              <NavLink
                to='/admin'
                className={mobileNavLinkClass}>
                <Crown className='h-5 w-5' />
                <span>admin</span>
              </NavLink>
            )}
            <button
              onClick={logout}
              className='duration-200 flex hover:text-tree-green items-center px-4 py-2 space-x-2 text-lg text-slate-500 transition-colors'>
              <LogOut className='h-5 w-5' />
              <span>log out</span>
            </button>
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <main className='container flex-1 mx-auto px-4 py-8'>
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;
